import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import { getContinueRewardIcon } from '../match2.icons';
import { matchTheme } from 'src/game/theme/match2/Match2Theme';

export default class Match2SocialContinueBuyPanel extends ImageScaleView {
  /** Existing moves icon lifted during the increased-offer animation. */
  public readonly movesBadge: ImageScaleView;
  public readonly movesLabel: LangBitmapFontTextView;
  private readonly buyMessage: LangBitmapFontTextView;

  constructor(
    opts: Omit<
      ImageScaleViewOpts,
      'image' | 'width' | 'height' | 'centerOnOrigin' | 'centerAnchor'
    > & { continues: number; amount: number },
  ) {
    super({
      ...opts,
      width: 253,
      height: 213,
      centerOnOrigin: true,
      centerAnchor: true,
      image: 'assets/ui/match2/common/panel_pinch.png',
    });

    const useDoubleBadge = opts.continues > 0;
    let offsetX = useDoubleBadge ? 52 : 0;

    this.movesBadge = new ImageScaleView({
      superview: this,
      image: `assets/ui/match2/common/pinch_moves.png`,
      width: 208,
      height: 217,
      centerOnOrigin: true,
      centerAnchor: true,
      x: this.style.width * 0.5 - offsetX,
      y: this.style.height * 0.5 - 20,
      scale: 0.55,
    });

    this.movesLabel = new LangBitmapFontTextView({
      superview: this,
      font: 'Title',
      color: '#FFFFFF',
      size: 45,
      x: this.style.width * 0.5 + 20 - offsetX,
      y: this.style.height * 0.5 - 20,
      centerOnOrigin: true,
      centerAnchor: true,
      localeText: () => `+${opts.amount}`,
      verticalAlign: 'center',
      align: 'center',
    });

    if (useDoubleBadge) {
      offsetX += 5;

      const panel = new ImageScaleView({
        superview: this,
        image: matchTheme().getUIAsset(`continue_bonus_panel.png`),
        width: 208,
        height: 217,
        centerOnOrigin: true,
        centerAnchor: true,
        x: this.style.width * 0.5 + offsetX,
        y: this.style.height * 0.5 - 14,
        scale: 0.45,
      });

      getContinueRewardIcon()
        ?.get()
        .then((image) => {
          new ImageScaleView({
            superview: panel,
            image,
            width: panel.style.width,
            height: panel.style.height,
          });
        });

      new LangBitmapFontTextView({
        superview: this,
        font: 'Title',
        color: '#FFB14A',
        size: 25,
        x: this.style.width * 0.5 + offsetX,
        y: 25,
        centerOnOrigin: true,
        centerAnchor: true,
        localeText: () => i18n('match2.movesPinch.bonus').toLocaleUpperCase(),
        verticalAlign: 'center',
        align: 'center',
      });

      if (opts.continues > 3) {
        new LangBitmapFontTextView({
          superview: this,
          font: 'Title',
          color: '#FFFFFF',
          size: 35,
          x: this.style.width * 0.5 + 20 + offsetX,
          y: this.style.height * 0.5 - 14,
          centerOnOrigin: true,
          centerAnchor: true,
          localeText: () => 'x2',
          verticalAlign: 'center',
          align: 'center',
        });
      }
    }

    this.buyMessage = new LangBitmapFontTextView({
      superview: this,
      font: 'Body',
      color: '#BF8147',
      size: 20,
      width: this.style.width - 50,
      x: this.style.width * 0.5,
      y: 165,
      centerOnOrigin: true,
      centerAnchor: true,
      localeText: () =>
        i18n('match2.socialContinue.buyMessage', { amount: opts.amount }),
      verticalAlign: 'center',
      align: 'center',
    });
  }

  /** Update the move count in both the badge and description. */
  public setNumMoves(numMoves: number): void {
    this.movesLabel.localeText = () => `+${numMoves}`;
    this.buyMessage.localeText = () =>
      i18n('match2.socialContinue.buyMessage', { amount: numMoves });
  }
}
